import styled from 'styled-components';
import { Button } from 'components/Input/Button';
import { useAnalytics } from 'hooks/useAnalytics';

import { DataDogLogger } from 'utils/dataDog';
import { open } from 'utils/url';

import { CHAT_UI_PREFIX } from 'constants/id';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';
import { ANALYTICS } from 'analytics/constants';
import { AnalyticClickedLinkDetailsType } from 'analytics/types';
import { TCustomComponentProps } from '../Markdown.types';

const StyledButton = styled(Button)`
  margin: 8px 0;
  text-align: left;
`;

export const CustomAnchor = ({ children, href }: TCustomComponentProps<HTMLAnchorElement>) => {
  const { trackEvent } = useAnalytics();

  const hrefText = children;

  const handleOnClick = () => {
    const logContext = { content: hrefText, url: href };
    trackEvent({
      analyticEvent: ANALYTICS.EVENT.CLICKED_LINK,
      details: {
        ...logContext,
        analytic_click_id: `${CHAT_UI_PREFIX}-markdown-embedded-href`,
      } as AnalyticClickedLinkDetailsType,
    });
    DataDogLogger.action(CUSTOM_ACTION_NAMES.MARKDOWN_LINK_CLICKED, logContext);
    open(href);
  };

  return (
    <StyledButton priority='text' size='medium' onClick={handleOnClick}>
      {hrefText}
    </StyledButton>
  );
};
